import * as React from "react"
 
import { cn } from "../../../@/lib/utils"
import { Field } from "formik"
import { FieldWrapper } from "../Additional/FieldWrapper"
import { Label } from "@radix-ui/react-label"
 
export interface TextareaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {}
 
const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, name, required, ...props }, ref) => {
    return (
      <FieldWrapper name={name ?? ''}>
        <Label className="block text-sm font-medium ">
          {props.title}
          {required && <span className="text-red-500 ml-1">*</span>}
        </Label>
        <Field
          name={name}
          as="textarea"
          className={cn(
            "flex min-h-[60px] w-full rounded-md border border-input bg-transparent px-3 py-2 text-sm shadow-sm placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
            className
          )}
          ref={ref}
          {...props}
        />
      </FieldWrapper>
    )
  }
)
Textarea.displayName = "Textarea"
 
export { Textarea }
